import getInstance from "app/config/api";

export default class Invoice {
  static async fetchInvoiceCompensationDashboard(params) {
    const instance = getInstance();
    const { data } = await instance.get(
      "/invoice/invoice-compensation-dashboard",
      {
        params,
      }
    );
    return data;
  }

  static async fetchDaysCompensationInvoice() {
    const instance = getInstance();
    const { data } = await instance.get(
      "/invoice/get-days-compensation-invoice"
    );
    return data;
  }
}
